// extracted by css-extract-rspack-plugin
export default {"cls1":"mentions_milestone_ping-cls1_f-I","cls2":"mentions_milestone_ping-cls2_Sop mentions_milestone_ping-cls1_f-I"};